module.exports = __webpack_public_path__ + "static/media/ios-sad.0a573786.svg";